<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>小程序管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form" :v-model="query"
        @submit.native.prevent="getList();">
        <el-form-item label="搜索" prop="name">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="企业">
          <el-select v-model="query.companyID" filterable clearable @change="getList();">
            <el-option v-for="item in accompany" :label="item.shortName" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible = true; form = { isEnable: true };">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>小程序记录列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width:100%;">
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <div>{{scope.row.name}}</div>
              <div class="mininame">
                <a :href="scope.row.backUrl" target="_blank" v-if="scope.row.backUrl">后台</a>
                <a  class="copybtn" @click="copyClick(scope.row)" v-if="scope.row.gitUrl">git</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="appId" label="appid"></el-table-column>
          <el-table-column prop="email" label="小程序账号"></el-table-column>
          <el-table-column prop="pwd" label="小程序密码"></el-table-column>
          <el-table-column prop="stateName" label="状态"></el-table-column>
          <el-table-column prop="companyName" label="所属公司"></el-table-column>
          <el-table-column prop="managerName" label="管理员名称"></el-table-column>
          <el-table-column prop="managerWechat" label="管理员微信"></el-table-column>
          <el-table-column prop="summary" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id > 0 ? '编辑小程序信息' : '添加小程序信息'" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-form-item label="小程序名称" prop="name" :rules="[
        { required: true, message: '请输入小程序名称' }
      ]">
          <el-input v-model="form.name" placeholder="请输入小程序名称"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="小程序账号" prop="email" :rules="[{ required: true, message: '请输入小程序账号' }]">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="小程序密码" prop="pwd">
              <el-input v-model="form.pwd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="AppId" prop="appId" :rules="[{ required: true, message: '请输入appId' }]">
              <el-input v-model="form.appId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="AppSecret" prop="appSecret">
              <el-input v-model="form.appSecret"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="小程序类型" prop="type" :rules="[{ required: true, message: '请输入小程序类型' }]">
              <el-select v-model="form.type" filterable>
                <el-option v-for="item in typeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="state" :rules="[{ required: true, message: '请选择状态' }]">
              <el-select v-model="form.state" filterable>
                <el-option v-for="item in stateList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="管理员姓名" prop="managerName">
          <el-input v-model="form.managerName"></el-input>
        </el-form-item>

        <el-form-item label="管理员微信" prop="managerWechat">
          <el-input v-model="form.managerWechat"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="summary">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属公司" prop="companyname">
              <el-select v-model="form.companyID" filterable>
                <el-option v-for="item in reverseCompany" :label="item.shortName" :value="item.id"
                  :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户名称" prop="payname">
              <el-select v-model="form.payID" filterable>
                <el-option v-for="item in merchanList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="后台地址" prop="backUrl">
          <el-input v-model="form.backUrl"></el-input>
        </el-form-item>
        <el-form-item label="git地址" prop="gitUrl">
          <el-input v-model="form.gitUrl"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      key: "",
      accompany: [], //企业列表
      merchanList: [], //商户列表
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      stateList: [
        {
          id: 1,
          name: "使用中"
        },
        {
          id: 2,
          name: "已关闭"
        },
        {
          id: -1,
          name: "已放弃"
        }
      ],
      typeList: [
        {
          id: 1,
          name: "企业小程序"
        },
        {
          id: 2,
          name: "个人小程序"
        },
        {
          id: 3,
          name: "其他"
        }
      ]
    };
  },
  computed: {
    reverseCompany: function () {
      return this.accompany.slice(0).reverse();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //获取小程序列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAccInfo("getlist_mini");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取企业列表
    company: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAccInfo("GetAll_Commany");
      $.get(link, params, data => {
        _this.loading = false;
        _this.accompany = data;
      });
    },
    //获取商户列表
    merchant: function () {
      var _this = this;
      _this.loading = true;
      var link = url.getAccInfo("getall_pay");
      $.get(link, {}, data => {
        _this.loading = false;
        _this.merchanList = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getAccInfo("addorupdate_mini");
      var info = this.form;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //复制git地址
    copyClick(row){
      let clipboard = new Clipboard(".copybtn", {
          text: function () {
            return row.gitUrl;
          },
        });
        clipboard.on("success", (e) => {
          this.$message({
            message: "复制成功",
            showClose: true,
            type: "success",
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          this.$message({
            message: "复制失败,",
            showClose: true,
            type: "error",
          });
          clipboard.destroy();
        });
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取企业列表
    this.company();
    //获取商户列表
    this.merchant();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.mininame{
  font-size:12px
}
.mininame a{
  display: inline-block;
  padding: 2px 5px;
  letter-spacing: 1px;
  color:rgb(64, 158, 255);
  cursor: pointer;
}
.mininame a:hover{
  color: red;
  font-size: 14px;
}
</style>
